import { createFacetColumn, ColumnWidth } from '../createColumn';
import { IColumn } from 'office-ui-fabric-react/lib/DetailsList';
import { Facet } from '../../../models/Facet';
import ColumnStrings from '../columns.resx';
import { retentionPolicyFacet } from '../../../facets/ItemFacets';
import { TextField } from '../../fields/text/TextField';
import { getBooleanDisplayValue } from '../../fields/FieldHelper';
import { RetentionPolicyType } from '../../../models/ItemPolicy';

export const retentionRecordColumn: IColumn = createFacetColumn({
  key: new Facet('retentionRecordColumn').id,
  name: ColumnStrings.ItemIsARecord,
  fieldName: '',
  minWidth: ColumnWidth.regularMin,
  maxWidth: ColumnWidth.regularMax
}, {
    retentionPolicy: retentionPolicyFacet
  },
  TextField)((facets: {
    retentionPolicy?: typeof retentionPolicyFacet.type;
  }) => {
    return {
      text: getBooleanDisplayValue((facets && facets.retentionPolicy && (facets.retentionPolicy === RetentionPolicyType.record)) || false)
    };
  });
